module.exports = __webpack_public_path__ + "static/microsoft-certified-azure-fundamentals-fc14eb773f6b73416c4265ea0724fd7f.png";